import Swiper from 'swiper/bundle'

export class Carousel {

    constructor ( target = '.js-carousel', options = {} ) {

        this.target = target;

        this.options = {
            slideClass: 'js-carousel__slide',
            wrapperClass: 'js-carousel__track',
            slideActiveClass: 'js-carousel__slide--active',
            noSwipingClass: 'js-carousel__no-swipe',
            ...options
        }

        this.observerOptions = {
            observer: {
                root: document.querySelector( 'body' ),
                rootMargin: '0px',
                threshold: 0.01
            },
            removeTarget: true,
            ...options
        }
    }

    init () {

        this.sliders = [];
        this.el = Array.from( document.querySelectorAll( this.target ) );

        if(this.el.length > 0) {
            this.sliderObserver = new IntersectionObserver( ( entries, observer ) => {
                this.create( entries, this )
            }, this.observerOptions );

            this.el.forEach( $el => {
                this.sliderObserver.observe( $el );
            } );
        }


    }

    create( entries, instance) {
        entries.forEach( ( entry ) => {
            if ( entry.isIntersecting ) {

                const $el = entry.target;
                const count = Array.from( $el.querySelectorAll( `.${this.options.slideClass}` ) ).length;
                const style = $el.dataset.style;

                let options;

                let $next = '.js-carousel__next';
                let $prev = '.js-carousel__prev';

                if ( count > 1 && style === 'coverflow' ) {
                    options = {
                        ...this.options,
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__control--disabled',
                        },
                        loop: true,
                        speed: 800,
                        slidesPerView: 1,
                        centeredSlides : true,
                        effect: 'slide',
                        breakpoints: {
                            1180: {
                                slidesPerView: 2 // I don't know why this works?
                            }
                        }
                    }
                } else if (count > 1) {
                    options = {
                        ...this.options,
                        slidesPerView: 1,
                        spaceBetween: 35,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        navigation: {
                            nextEl: $next,
                            prevEl: $prev,
                            disabledClass: 'js-carousel__control--disabled',
                        },
                        pagination: {
                            el: '.js-carousel__pages',
                            type: 'fraction',
                            clickable: false
                        }
                    }
                } else {
                    options = {
                        ...this.options,
                        slidesPerView: 1,
                    }
                    const $controls = $el.querySelector( `.c-slider__controls` );
                    const $pager = $el.querySelector( `.c-slider__pages` );
                    if($controls) {
                        $controls.remove();
                    }
                    if($pager) {
                        $pager.remove();
                    }
                }

                this.sliders.push( new Swiper( $el, options ) );
            }
        })
    }

    destroy () {
        if(this.el.length > 0) {
            this.sliderObserver.disconnect();
        }
        this.sliders.forEach( slider => {
            slider.destroy();
        } )
    }
}